module.exports = __webpack_public_path__ + "media/images/sp/top/recommend_plan_maedori-eabb8549994fe6065fba5f3b9eb9d7b8.webp";